import { render } from "./outbox.vue?vue&type=template&id=08c4782b&scoped=true"
import script from "./outbox.vue?vue&type=script&lang=js"
export * from "./outbox.vue?vue&type=script&lang=js"

import "./outbox.vue?vue&type=style&index=0&id=08c4782b&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c4782b"]])

export default __exports__